import * as types from '../mutation-types';
import _ from 'lodash';

const state = {
  queue: [],
  defaults: {
    text: null,
    colour: null,
    top: false,
    bottom: true,
    left: false,
    right: false,
    timeout: 6000
  }
};

const getters = {
  NotificationQueue: state => state.queue,
  NotificationsPending: state => state.queue.length > 0
};

const actions = {
  addNotification({ commit }, notification) {
    commit(types.ADD_NOTIFICATION, notification);
  },
  shiftNotification({ commit }) {
    commit(types.CLEAR_NOTIFICATION);
  }
};

const mutations = {
  [types.ADD_NOTIFICATION](state, notification) {
    const item = _.defaults(notification, state.defaults);
    state.queue.push(item);
  },
  [types.CLEAR_NOTIFICATION](state) {
    state.queue.shift();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
